// מקור המידע של קרן/קובץ — מאיפה הגיעו הנתונים.
// זהו מקור אמת יחיד לתוויות המקור בכל האפליקציה (כרטיס לקוח, מנהל קבצים).
//
//   masleka     — העלאה כללית של קבצי המסלקה הפנסיונית (מבנה אחיד 008, טרום-ייעוץ + אחזקות)
//   prat        — קובץ ישיר מחברת ביטוח (כלל, מגדל, הכשרה, הראל, מנורה)
//   managed     — דוח תיק מנוהל מבית השקעות (מור, ילין לפידות)
//   har_bituach — הר הביטוח (עתידי; שמור)

export const SOURCE_TYPE = {
  MASLEKA: "masleka",
  PRAT: "prat",
  MANAGED: "managed",
  HAR_BITUACH: "har_bituach",
  ALTSHULER_EXCEL: "altshuler_excel",
};

export const SOURCE_META = {
  masleka:     { label: "מסלקה",       icon: "🏛️", bg: "#dbeafe", color: "#1e3a8a" },
  prat:        { label: "פרט",         icon: "🏢", bg: "#f5f3ff", color: "#6d28d9" },
  managed:     { label: "ניהול תיקים", icon: "📈", bg: "#f0f9ff", color: "#0369a1" },
  har_bituach: { label: "הר הביטוח",   icon: "🏔️", bg: "#f0fdf4", color: "#166534" },
  altshuler_excel: { label: "עמלות אלטשולר (!)", icon: "⚠️", bg: "#fef3c7", color: "#d97706" },
};

// מטא-דאטה בטוח לתצוגה — נופל אחורה בעדינות אם ה-sourceType לא מזוהה.
export function sourceMeta(sourceType) {
  return SOURCE_META[sourceType] || null;
}

// תצוגה בינארית לעמודת המקור בכרטיס הלקוח: מסלקה מול "פרודוקציה ידנית" (כל השאר).
// קבצי הלוגו נטענים מ-public/ ; אם לא קיימים — נופלים לאימוג'י (emoji) דרך onError.
export function sourceLogo(sourceType) {
  if (sourceType === SOURCE_TYPE.ALTSHULER_EXCEL) {
    return { src: "/logos/altshuler.png", label: "דוח עמלות אלטשולר (!)", fallback: "⚠️" };
  }
  const isMasleka = sourceType === SOURCE_TYPE.MASLEKA;
  return isMasleka
    ? { src: "/masleka-logo.png", label: "מסלקה",           fallback: "🏛️" }
    : { src: "/manual-logo.png",  label: "פרודוקציה ידנית", fallback: "✍️" };
}
